/* Purchase options — drives variant and selling plan selection from the
   purchase-option cards rendered by snippets/purchase-options.liquid.

   Templates using this component may have the variant_picker block disabled, so
   the selected card is the single source of truth for both the variant id and
   the selling plan id submitted with the product form. */

if (!customElements.get('purchase-options')) {
  customElements.define(
    'purchase-options',
    class PurchaseOptions extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        this.inputs = Array.from(this.querySelectorAll('.purchase-option__input'));
        if (this.inputs.length === 0) return;

        this.sellingPlanInput = this.querySelector('[data-purchase-options-selling-plan]');
        this.form = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;

        this.addEventListener('change', this.onChange);

        // Nothing checked server-side (for example the previously selected
        // variant is sold out) — fall back to the first available option.
        if (!this.inputs.some((input) => input.checked)) {
          this.inputs[0].checked = true;
        }

        this.apply(this.checkedInput);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      get checkedInput() {
        return this.inputs.find((input) => input.checked) || null;
      }

      onChange = (event) => {
        if (!event.target.classList.contains('purchase-option__input')) return;
        this.apply(event.target);
      };

      apply(input) {
        if (!input) return;

        this.syncSelectedState(input);
        this.syncSellingPlan(input);
        this.syncVariant(input);
      }

      /* Class fallback so the selected state also works without :has() */
      syncSelectedState(input) {
        this.inputs.forEach((option) => {
          const card = option.closest('.purchase-option');
          if (card) card.classList.toggle('purchase-option--selected', option === input);
        });
      }

      syncSellingPlan(input) {
        if (!this.sellingPlanInput) return;

        const planId = input.dataset.sellingPlanId || '';
        if (this.sellingPlanInput.value === planId) return;

        this.sellingPlanInput.value = planId;
        // An empty selling_plan must not be submitted as a one-time purchase
        // key, so the input is disabled rather than sent blank.
        this.sellingPlanInput.disabled = planId === '';
        this.sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncVariant(input) {
        const variantId = input.dataset.variantId;
        if (!variantId) return;

        const variantInput = this.variantInput();
        if (!variantInput || variantInput.value === variantId) return;

        variantInput.value = variantId;
        variantInput.disabled = false;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      variantInput() {
        const scope = this.form || document;
        return (
          scope.querySelector('input[name="id"].product-variant-id') ||
          scope.querySelector('input[name="id"]')
        );
      }
    }
  );
}
